import {
  CreateNormasTeachingProductForm,
  CreateNormasTeachingProductFormValues,
} from "./CreateNormasTeachingProductForm.tsx";
import { Layout } from "../../UI/Layout/Layout.tsx";
import { NavBar } from "../../UI/Layout/NavBar.tsx";
import { Footer } from "../../UI/Layout/Footer.tsx";
import { FullPageLoading } from "../../UI/FullPageLoading.tsx";
import { useNavigate } from "react-router";
import { AdminMainContainer } from "../../UI/Admin/AdminMainContainer.tsx";
import { KnownProduct } from "../Product/KnownProduct.tsx";
import { useKnownPurchaseAcTags } from "../../ProductService/useKnownPurchaseAcTags.ts";
import { useKnownRefundAcTags } from "../../ProductService/useKnownRefundAcTags.ts";
import { AdminAllNormasTeachingProductScreenPath } from "./AdminAllNormasTeachingProductScreen.tsx";
import { useAllNormasTeachingProducts } from "../../ProductService/NormasTeachingProduct/useAllNormasTeachingProducts.ts";
import { useCreateNormasTeachingProduct } from "../../ProductService/NormasTeachingProduct/useCreateNormasTeachingProduct.ts";
import { useKnownAnalyticsTags } from "../../ProductService/useKnownAnalyticsTags.ts";

export const CreateNormasTeachingProductScreenPath =
  "/admin/normasteaching/create-product";
export function CreateNormasTeachingProductScreen() {
  const { isLoading: isLoadingPurchaseTags, purchaseTags } =
    useKnownPurchaseAcTags("products");
  const { isLoading: isLoadingRefundTags, refundTags } =
    useKnownRefundAcTags("products");
  const { isLoading: isLoadingAnalyticsTags, analyticsTags } =
    useKnownAnalyticsTags("products");

  const { products, isLoading: isLoadingProducts } =
    useAllNormasTeachingProducts();

  const { createNormasTeachingProduct, loading: creating } =
    useCreateNormasTeachingProduct();

  const navigate = useNavigate();

  const loading =
    isLoadingPurchaseTags ||
    isLoadingRefundTags ||
    isLoadingProducts ||
    isLoadingAnalyticsTags;

  const onSubmit = async (
    data: CreateNormasTeachingProductFormValues,
  ): Promise<void> => {
    await createNormasTeachingProduct({
      productName: data.productName,
      variantProductName: data.variantProductName,
      productClass: data.productClass,
      priceInCents: { amount: data.priceInEuros * 100, currency: "EUR" },
      bundledProductIds: data.bundledProductIds ?? [],
      purchaseAcTags: data.purchaseAcTags ?? [],
      refundAcTags: data.refundAcTags ?? [],
      peopleCount: data.peopleCount,
      fpsProductInfo:
        data.productClass === KnownProduct.FPS
          ? {
              durationInWeeks: data.fpsLessonsDurationInWeeks || 0,
              unlimitedLessonsPerWeek: data.fpsUnlimitedLessonsPerWeek || false,
              lessonsPerWeek: data.fpsLessonsPerWeek || 0,
              totalLessons: data.fpsTotalLessons || 0,
              extraWeek: data.fpsExtraWeek || false,
              warrantyEnabled: data.fpsWarrantyEnabled || false,
              warrantyMinAttendedLessons:
                data.fpsWarrantyMinAttendedLessons || 0,
              userGroupSlug: data.userGroupSlug,
              doNotEnroll: data.doNotEnroll,
              doNotMerge: data.oneOnOne ? false : data.doNotMerge,
              oneOnOne: data.oneOnOne,
              oneOnOneTotalLessons: data.oneOnOneTotalLessons ?? 0,
              oneOnOneDurationInWeeks: data.oneOnOneDurationInWeeks ?? 0,
              oneOnOneMaxCancellations: data.oneOnOneMaxCancellations ?? 0,
              oneOnOneLessonType: data.oneOnOneLessonType,
            }
          : undefined,
      analyticsTag: data.analyticsTag,
      stripeConfig: data.stripeConfig,
      heylightConfig: data.heylightConfig,
      productDescription: data.productDescription,
      isCouponEnabled: data.isCouponEnabled,
    });
    navigate(AdminAllNormasTeachingProductScreenPath);
  };
  if (loading) return <FullPageLoading />;
  return (
    <Layout>
      <AdminMainContainer>
        <NavBar showAdminSideBarHandle />
        <div className={"p-4 flex-1 flex items-center"}>
          <div
            className={
              "max-w-[1024px]  w-full mx-auto bg-white p-4 rounded-lg flex flex-col gap-4"
            }
          >
            <h1 className={"font-bold text-2xl"}>Crea nuovo prodotto</h1>
            <CreateNormasTeachingProductForm
              onSubmit={onSubmit}
              products={products}
              creating={creating}
              initialKnownPurchaseAcTags={purchaseTags}
              initialKnownRefundAcTags={refundTags}
              initialKnownAnalyticsTags={analyticsTags}
            />
          </div>
        </div>
      </AdminMainContainer>
      <Footer />
    </Layout>
  );
}
